import { MenusType } from "@/core/types/contentTypes";
import useDataRequestOrder from "@/core/dataProviders/hooks/useDataRequestOrder";
import useLangSelector from "@/core/dataProviders/hooks/useLangSelector";
import { useAppSelector } from "@/core/store/reduxHooks";
import useDataRequestState from "@/core/dataProviders/hooks/useDataRequestState";
import { DataRequestStateEnum, DataRequestType } from "@/core/types/dataRequestsTypes";
import { MenuByGroupSelector } from "@/core/store/menu/MenuSlice";
import { useEffect, useState } from "react";
import isNewOrderNeeded from "@/core/dataProviders/utils/isNewOrderNeeded";

/**
 * data provider for front-end pages based on available options for given data
 * - checks if order exists / creates orders / returns order status
 * - gathers and returns requested data
 * */

const useMenusProvider = (): [MenusType | null, DataRequestStateEnum] => {
  const orderData = useDataRequestOrder();
  const menusData = useLangSelector(useAppSelector(MenuByGroupSelector));

  const [currentReqState] = useDataRequestState({
    type: DataRequestType.MENUS,
    sign: { slug: DataRequestType.MENUS },
  });
  const [currentMenusData, setCurrentMenusData] = useState<MenusType | null>(menusData ? menusData : null);

  useEffect(() => {
    setCurrentMenusData(menusData ? menusData : null);
  }, [menusData]);

  useEffect(() => {
    if (isNewOrderNeeded(!!currentMenusData, currentReqState)) {
      return;
    }

    orderData({
      type: DataRequestType.MENUS,
      sign: { slug: DataRequestType.MENUS },
    });
  }, [currentReqState, orderData]);

  return [currentMenusData, currentReqState];
};

export default useMenusProvider;
